import { useQuery } from "@tanstack/react-query";
import { getServiceStatus } from "../../webService/webService";
import { queryKeys } from "../queryKeys";

const POLL_INTERVAL_MS = 60_000;

/**
 * Polls whether Teco is currently open for checkout. This is a UX signal
 * only — the real enforcement happens server-side in mzito-pay before any
 * payment is charged, so a stale/failed poll here should never be treated
 * as authoritative.
 */
export const useServiceStatusQuery = (options = {}) =>
  useQuery({
    queryKey: queryKeys.serviceStatus.all,
    queryFn: getServiceStatus,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    staleTime: POLL_INTERVAL_MS,
    ...options,
  });
